import Vue from 'vue';
import App from './App';
import $ from 'webpack-zepto';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-default/index.css';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import VueRouter from 'vue-router';
import filters from './filters';
import routes from './routers';
import Alert from './libs/alert';
import store from './vuex/user';
import FastClick from 'fastclick';
import Countly from './libs/countly';

Vue.use(VueRouter);
Vue.use(Alert);
Vue.use(ElementUI);

$.ajaxSettings.crossDomain = true;

NProgress.configure({ showSpinner: false });
// 实例化Vue的filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

// 实例化VueRouter
const router = new VueRouter({
    mode: 'history',
    routes
});
FastClick.attach(document.body);

// 处理刷新的时候vuex被清空但是用户已经登录的情况
if (window.sessionStorage.user) {
    store.dispatch('setUserInfo', JSON.parse(window.sessionStorage.user));
}

Countly.init({
    app_key: '15e77d9602d2be184de65616f9abf705d41eec75',
    url: 'http://101.200.204.200/'
});
Countly.track_sessions();
Countly.track_pageview();
// 登录中间验证，页面需要登录而没有登录的情况直接跳转登录
router.beforeEach((to, from, next) => {
    // 处理左侧滚动不影响右边
    $('html, body, #page').removeClass('scroll-hide');
    if (to) {
        Countly.add_event({
            key: to.name,
            segmentation: {
                'id': to.path
            }
        });
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.state.userInfo.userId) {
            next();
        } else {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        }
    } else {
        next();
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js